/**
 * Detects a coarse device category from the User-Agent string.
 * Used for provider fraud/3DS payloads where device channel is required.
 */
function getDeviceType() {
  const userAgent = window.navigator?.userAgent || '';

  if (/tablet|ipad/i.test(userAgent)) {
    return 'tablet';
  }

  if (/mobi|android|iphone/i.test(userAgent)) {
    return 'mobile';
  }

  return 'desktop';
}

/**
 * Collects browser-side data for fraud checks.
 */
export function getBrowserInfo() {
  const screen = window.screen || { width: '', height: '', colorDepth: '' };
  const nav = window.navigator || {};

  return {
    browser_tz: String(new Date().getTimezoneOffset()),
    browser_screen_width: String(screen.width ?? ''),
    browser_screen_height: String(screen.height ?? ''),
    browser_color_depth: String(screen.colorDepth ?? ''),
    browser_language: nav.language || nav.browserLanguage || nav.userLanguage || '',
    // navigator.javaEnabled() is deprecated and always returns false in modern browsers
    // Field is still required by 3DS2/EMV3DS spec format
    browser_java_enabled: typeof nav.javaEnabled === 'function' ? nav.javaEnabled() : false,
    browser_user_agent: nav.userAgent || '',
    window_width: String(window.innerWidth ?? ''),
    window_height: String(window.innerHeight ?? ''),
    device_channel: getDeviceType(),
  };
}
